export default (() => {
  $('.entrytype-microsite-page .content-inner:not(.h2-widgets-default) .component').each(function () {
    $(this).find('h2, .h2').eq(0).addClass('widget');
  });
})()
